import { render, staticRenderFns } from "./editAdvertise.vue?vue&type=template&id=a0573ca2&scoped=true&"
import script from "./editAdvertise.vue?vue&type=script&lang=js&"
export * from "./editAdvertise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0573ca2",
  null
  
)

export default component.exports